// External Dependencies:
import React from 'react'
import { Link, NavLink } from 'react-router-dom'

class ListenPage extends React.Component {
	render() {
		return (
			<div className="listen-page-content mobile-app-top-page">
				<div className="-bg"></div>

				<div className="-menu">
					<NavLink to='/now-playing' exact activeClassName="is-active">Now Playing</NavLink>
					<NavLink to='/stations' exact activeClassName="is-active">Stations</NavLink>
					<NavLink to='/programs' exact activeClassName="is-active">Programs</NavLink>
					<NavLink to='/schedule' exact activeClassName="is-active">Schedule</NavLink>
				</div>
			</div>
		)
	}
}

export default ListenPage
